/* The Reset Year theme: review carousel dots on phones */
(function () {
  document.querySelectorAll('[data-rs-carousel]').forEach(function (track) {
    var dots = track.parentElement.querySelector('[data-rs-dots]');
    if (!dots) return;
    var items = track.children;
    var marks = dots.children;
    var update = function () {
      var left = track.scrollLeft;
      var best = 0;
      for (var i = 0; i < items.length; i++) {
        if (Math.abs(items[i].offsetLeft - track.offsetLeft - left) < Math.abs(items[best].offsetLeft - track.offsetLeft - left)) best = i;
      }
      for (var j = 0; j < marks.length; j++) marks[j].classList.toggle('is-active', j === best);
    };
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
  });
})();
